import {useApiClient as coreUseApiClient} from '@sollapay/web-core';

import {config} from '@/app';

export function useApiClient() {
  return coreUseApiClient({baseUrl: `${config.apiUrl}/v1/api`});
}
